import { render, staticRenderFns } from "./remarkDailyReport.vue?vue&type=template&id=5264bd1c&scoped=true"
import script from "./remarkDailyReport.vue?vue&type=script&lang=js"
export * from "./remarkDailyReport.vue?vue&type=script&lang=js"
import style0 from "./remarkDailyReport.vue?vue&type=style&index=0&id=5264bd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5264bd1c",
  null
  
)

export default component.exports